import React from 'react';
import { FolderPlus, Link2, ClipboardCheck } from 'lucide-react';

export const HowItWorks = () => {
  const steps = [
    {
      icon: FolderPlus,
      title: 'Crea tu aula',
      description: 'Registra tus aulas en segundos con nombre, materia y horario.',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      icon: Link2,
      title: 'Comparte el link',
      description: 'Genera un link único e invita a tus estudiantes sin complicaciones.',
      color: 'bg-cyan-100 text-cyan-600'
    },
    {
      icon: ClipboardCheck,
      title: 'Toma asistencia y reporta',
      description: 'Registra asistencia diaria y genera reportes automáticos por periodo.',
      color: 'bg-teal-100 text-teal-600'
    }
  ];

  return (
    <section id="como-funciona" className="py-20 lg:py-28 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Tan fácil como <span className="text-blue-600">1, 2, 3</span>
          </h2>
          <p className="text-lg text-gray-600">
            Comienza a tomar asistencia en menos de 5 minutos
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 max-w-6xl mx-auto">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={index}
                className="relative group"
              >
                {/* Step number */}
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg z-10">
                  {index + 1}
                </div>

                {/* Card */}
                <div className="bg-gray-50 rounded-2xl p-8 h-full hover:shadow-lg transition-shadow duration-300">
                  <div className={`${step.color} w-16 h-16 rounded-xl flex items-center justify-center mb-6`}>
                    <Icon size={32} strokeWidth={2} />
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {step.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Connector line (hidden on mobile, shown on md+) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/3 left-full w-12 lg:w-16 h-0.5 bg-gradient-to-r from-gray-300 to-transparent -translate-y-1/2 z-0"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
